import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const HOME_BY_ROLE = { admin: "/dashboard", sales: "/leads", technician: "/services" };

// Explicit user permission wins over role check (both grant AND deny).
function isPermitted(user, roles, perm) {
  if (perm && user.permissions) {
    if (user.permissions[perm] === true) return true;
    if (user.permissions[perm] === false) return false;
  }
  if (roles && roles.length) return roles.includes(user.role);
  return true;
}

export default function ProtectedRoute({ children, roles, perm }) {
  const { user, ready } = useAuth();
  if (!ready) return (
    <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="auth-loading">
      Loading...
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (!isPermitted(user, roles, perm)) {
    return <Navigate to={HOME_BY_ROLE[user.role] || "/login"} replace />;
  }
  return children;
}
